import {isNumber} from '@/_application/core/utils/number';

export const convertCurrencyToNumeric = (currencyString: string) => {
    const numeric = isNumber(currencyString.replace(/\D/g, '')) ? currencyString.replace(/\D/g, '') : '0';
    return Number(numeric);
};

export const calculateDiscountPercentage = (basePrice: string, discountedPrice: string, decimalPlaces = 0) => {
    const basePriceNumeric = convertCurrencyToNumeric(basePrice);
    const discountedPriceNumeric = convertCurrencyToNumeric(discountedPrice);

    if (basePriceNumeric > discountedPriceNumeric) {
        const discountAmount = basePriceNumeric - discountedPriceNumeric;
        const discountPercentage = (discountAmount / basePriceNumeric) * 100;

        const roundedDiscountPercentage = discountPercentage.toFixed(decimalPlaces);

        return roundedDiscountPercentage;
    } else {
        return null;
    }
};
